import script from "./AuthModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthModal.vue?vue&type=script&setup=true&lang=js"

import "./AuthModal.vue?vue&type=style&index=0&id=3d7d6db0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7d6db0"]])

export default __exports__